import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Layout/Header';
import Menu from './Menu';
import {
  ToastifyContainer,
  consumeQueuedToastifyMessage,
  toastifyMessage,
} from '../../components/Toastify/Toastify';
import MobileUnsupported from '../../components/MobileUnsupported/MobileUnsupported';

const LayoutDash = (props) => {
  const { children } = props;
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const media = window.matchMedia('(max-width: 768px)');
    const handleChange = () => setIsMobile(media.matches);
    handleChange();
    if (media.addEventListener) {
      media.addEventListener('change', handleChange);
      return () => media.removeEventListener('change', handleChange);
    }
    media.addListener(handleChange);
    return () => media.removeListener(handleChange);
  }, []);

  useEffect(() => {
    const pendingMessage = consumeQueuedToastifyMessage();
    if (pendingMessage) {
      toastifyMessage(pendingMessage);
    }
  }, [location.pathname]);

  if (isMobile) {
    return <MobileUnsupported />;
  }

  return (
    <div className="layout__dash">
      <Header />
      <ToastifyContainer />
      <Menu />
      <main className="page">
        <section className="dashboard">
          <div className="dashboard__wrapper overflow-scroll" id="layout-dash-scroll">
            {children}
          </div>
        </section>
      </main>
    </div>
  );
};

export default LayoutDash;
